import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-x-large);
	align-items: center;
	justify-content: center;

	.pie {
		position: relative;
		.total {
			position: absolute;
			z-index: 1;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			display: flex;
			flex-direction: column;
			gap: var(--spacing-xx-small);
			align-items: center;
		}
	}
`;
